import { render, staticRenderFns } from "./TableAllData.vue?vue&type=template&id=54e6f59c&"
import script from "./TableAllData.vue?vue&type=script&lang=js&"
export * from "./TableAllData.vue?vue&type=script&lang=js&"
import style0 from "./TableAllData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports